import React, { useEffect, useState } from "react";
import {useDaumPostcodePopup} from 'react-daum-postcode';
import * as U from "../../style/StyleComponentUtility";
import { useDispatch } from "react-redux";
import { reduxChangeCustomerDetailAddress1, reduxChangeCustomerDetailAddress2, reduxChangePostcode1, reduxChangePostcode2 } from "../../redux/EstimateSlice";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/Store";
import { PostCode } from "../../model/product";
import { reduxChangeCustomerDetailAddress3, reduxChangeCustomerDetailAddress4, reduxChangeInstallDetailAddress, reduxChangeInstallPostcode, reduxChangePostcode3, reduxChangePostcode4 } from "../../redux/ReservationSlice";

type Props = {
    addressSelect : number;
};
// addressSelect : 1 => 견적 이동시공 예전주소, 2 => 견적 이동시공 시공할 주소, 3 => 예약 이동시공 예전주소, 4 => 예약 이동시공 시공할 주소, 5 => 예약 탈거+시공 동시 시공지 주소

const DaumPostCode: React.FC<Props> = ({ addressSelect }) => {
    const dispatch = useDispatch();
    const estimateData = useSelector((state: RootState) => state.estimateData);
    const reservationData = useSelector((state: RootState) => state.reservationData);
    
    const [zipcode, setZipcode] = useState("");
    const [address, setAddress] = useState("");
    const [detailAddress, setDetailAddress] = useState("");

    useEffect(() => {
        switch(addressSelect) {
            case 1 :
                setZipcode(estimateData.postcode_1.zip_code);
                setAddress(estimateData.postcode_1.address);
                setDetailAddress(estimateData.postcode_1.detail_address);
                break;
            case 2 :
                setZipcode(estimateData.postcode_2.zip_code);
                setAddress(estimateData.postcode_2.address);
                setDetailAddress(estimateData.postcode_2.detail_address);
                break;
            case 3 :
                setZipcode(reservationData.postcode_3.zip_code);
                setAddress(reservationData.postcode_3.address);
                setDetailAddress(reservationData.postcode_3.detail_address);
                break;
            case 4 :
                setZipcode(reservationData.postcode_4.zip_code);
                setAddress(reservationData.postcode_4.address);
                setDetailAddress(reservationData.postcode_4.detail_address);
                break;
            case 5 :
                setZipcode(reservationData.install_postcode.zip_code);
                setAddress(reservationData.install_postcode.address);
                setDetailAddress(reservationData.install_postcode.detail_address);
                break;
            default : break;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // 탈거+시공 동시 진행 시 "동일하게" 복사 등 외부에서 시공지 주소가 변경되면 반영
    useEffect(() => {
        if (addressSelect !== 5) return;
        setZipcode(reservationData.install_postcode.zip_code);
        setAddress(reservationData.install_postcode.address);
        setDetailAddress(reservationData.install_postcode.detail_address);
    }, [addressSelect, reservationData.install_postcode]);

    const open = useDaumPostcodePopup();

    const handleComplete = (data:any) => {
        let fullAddress = data.roadAddress;
        if(data.addressType === 'J') {
            fullAddress = data.autoRoadAddress;
            if(!data.autoRoadAddress) {
                fullAddress = data.roadAddress;
            }
        }
        let extraAddress = '';

        if (data.addressType === 'R') {
            if (data.bname !== '') {
                extraAddress += data.bname;
            }
            if (data.buildingName !== '') {
                extraAddress += extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName;
            }
            fullAddress += extraAddress !== '' ? ` (${extraAddress})` : '';
        }
        setAddress(fullAddress);
        setZipcode(data.zonecode);
        setDetailAddress("");
        let obj:PostCode = {
            address        : fullAddress,
            zip_code       : data.zonecode,
            detail_address : "",
            sido           : data.sido,
            sigungu        : data.sigungu,
        };
        switch(addressSelect) {
            case 1  : dispatch(reduxChangePostcode1(obj)); break;
            case 2  : dispatch(reduxChangePostcode2(obj)); break;
            case 3  : dispatch(reduxChangePostcode3(obj)); break;
            case 4  : dispatch(reduxChangePostcode4(obj)); break;
            case 5  : dispatch(reduxChangeInstallPostcode(obj)); break;
            default : break;
        };
    };

    const handleClick = () => {
        open({ onComplete: handleComplete });
    };

    const handleDetailAddress = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDetailAddress(e.target.value);
        switch(addressSelect) {
            case 1  : dispatch(reduxChangeCustomerDetailAddress1(e.target.value)); break;
            case 2  : dispatch(reduxChangeCustomerDetailAddress2(e.target.value)); break;
            case 3  : dispatch(reduxChangeCustomerDetailAddress3(e.target.value)); break;
            case 4  : dispatch(reduxChangeCustomerDetailAddress4(e.target.value)); break;
            case 5  : dispatch(reduxChangeInstallDetailAddress(e.target.value)); break;
            default : break;
        };
    };

    return (
        <U.PostCodeBox>
            <div>
                <input type="text" onClick={handleClick} placeholder="우편번호" className="zipcode-input cursor-pointer" value={zipcode} readOnly />
                <U.SearchPostButton type='button' onClick={handleClick}>주소 검색</U.SearchPostButton>
            </div>
            <div>
                <input type="text" onClick={handleClick} placeholder="주소" className="postcode-input cursor-pointer" value={address} readOnly />
            </div>
            <div>
                <input type="text" placeholder="상세주소 입력" className="postcode-input" onChange={handleDetailAddress} value={detailAddress} />
            </div>
        </U.PostCodeBox>
    );
};

export default DaumPostCode;